import { types } from 'mobx-state-tree';
import LanguageUrl from './LanguageUrl';
import NewsletterTag from './NewsletterTag';

export default types.model('Country', {
	CountryName: types.string,
    CountryCode: types.string,
    CountryGroup: types.string,
    MarketCode: types.string,
    ExternalUrl: types.string,
    LanguageUrls: types.optional(types.array(LanguageUrl), []),
    NewsletterTags: types.optional(types.array(NewsletterTag), [])
}).views(self => ({
    get Path() { // 
        return "/market-selector";
    }

})).actions(self => ({
	
}));
